<template>
  <div>
    <div class="columns is-multiline status-metadata">
      <div class="column is-3" v-if="networks.length">
        <div class="has-text-grey">Network</div>
        <span>{{ networks.join(', ') }}</span>
      </div>
      <div class="column is-3" v-if="amount.level">
        <div class="has-text-grey">Level</div>
        <span>{{ amount.level }}</span>
      </div>
      <div class="column is-3" v-if="amount.plan_network_name || amount.planNetworkName">
        <div class="has-text-grey">Plan Network</div>
        <span>{{ amount.plan_network_name || amount.planNetworkName }}</span>
      </div>
      <div class="column is-2" v-if="amount.plan_number || amount.planNumber">
        <div class="has-text-grey">Plan Number</div>
        <span>{{ amount.plan_number || amount.planNumber }}</span>
      </div>
      <div class="column is-2" v-if="amount.benefit_start">
        <div class="has-text-grey">Benefit Begin</div>
        <span>{{ amount.benefit_start | formatDate }}</span>
      </div>
      <div class="column is-2" v-if="amount.benefit_end">
        <div class="has-text-grey">Benefit End</div>
        <span>{{ amount.benefit_end | formatDate }}</span>
      </div>
      <div class="column is-2" v-if="amount.coverage_start">
        <div class="has-text-grey">Coverage Begin</div>
        <span>{{ amount.coverage_start | formatDate }}</span>
      </div>
      <div class="column is-2" v-if="amount.coverage_end">
        <div class="has-text-grey">Coverage End</div>
        <span>{{ amount.coverage_end | formatDate }}</span>
      </div>
      <div class="column is-2" v-if="amount.insurance_type">
        <div class="has-text-grey">Insurance Type</div>
        <!-- <span v-if="amount.insurance_type_code == 'PR'">PPO</span> -->
        <span>{{ amount.insurance_type }}</span>
      </div>
      <div class="column is-2" v-if="amount.description">
        <div class="has-text-grey">Description</div>
        <span>{{ amount.description }}</span>
      </div>
    </div>
    <PayerNotes :notes="amount.notes" />
    <br />
    <ContactList :contacts="amount.contacts" />
  </div>
</template>

<script>
import PayerNotes from './PayerNotes';
import ContactList from './ContactList';

export default {
  name: 'BenefitAmountStatus',
  components: {
    PayerNotes,
    ContactList,
  },
  props: {
    amount: Object,
    networks: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style scoped>
.status-metadata { display: grid; grid-template-columns: repeat(auto-fit, minmax(130px, 1fr)); gap: 0.75rem 1rem; margin: 0; }
.status-metadata > .column { width: auto; min-width: 0; padding: 0; font-size: 0.9rem; overflow-wrap: anywhere; }

pre {
  white-space: pre-wrap;
  word-wrap: anywhere;
}
.content ul {
  margin-top: 0;
}
</style>
